import { gql } from '@apollo/client/core';

/**
 * Selections for the superadmin genre screens. Keep these in step with `Type.ts`, `Category.ts` and
 * `Subcategory.ts` — every field selected here is mapped there, and nothing more is selected than is
 * mapped.
 *
 * `InternalCategoryFields` carries its `subcategories` rather than leaving them to each call site.
 * The App module splits them only because `CategoryFields` is spread on `AnnounceDetail` and in the
 * event query, where the children are not wanted; nothing reuses this fragment that way, so a split
 * would only give the catalog query and `saveCategory` two chances to forget the selection and hand
 * back a category whose `subcategories` is silently empty.
 *
 * The names are `Internal*`-prefixed, matching `InternalTicketLayoutFields` and
 * `InternalAppConfigFields`: `api/App/Genre/fragments.ts` still defines `TypeFields`,
 * `CategoryFields` and `SubcategoryFields` for the tenant announce surface, and two fragments of one
 * name in a single Apollo document is at best a runtime warning.
 */

export const INTERNAL_TYPE_FIELDS = gql`
  fragment InternalTypeFields on Type {
    id
    name
  }
`;

export const INTERNAL_SUBCATEGORY_FIELDS = gql`
  fragment InternalSubcategoryFields on Subcategory {
    id
    categoryId
    name
  }
`;

export const INTERNAL_CATEGORY_FIELDS = gql`
  fragment InternalCategoryFields on Category {
    id
    name
    subcategories {
      ...InternalSubcategoryFields
    }
  }
  ${INTERNAL_SUBCATEGORY_FIELDS}
`;
